import React from 'react';

const PartnerBankIcon = ({ size }) => (
  <svg xmlns="http://www.w3.org/2000/svg" id="svg3907" version="1.1" viewBox="0 0 12.7 12.7" height={size} width={size}>
    <defs id="defs3901">
      <clipPath id="clip-path-3">
        <path
          id="path147"
          d="m 80.47,23.09 a 11,11 0 0 0 7.85,4.58 14.56,14.56 0 0 0 1.87,0.12 c 11.88,0 17.59,-14.37 9.35,-22.61 a 13.24,13.24 0 0 0 -18.72,0 l -9.38,9.35 3,2.9 9.2,-9.64 a 9.45,9.45 0 1 1 6.73,16.09 8.15,8.15 0 0 1 -7,-3.57 z"
          className="cls-1"
        />
      </clipPath>
      <linearGradient
        xlinkHref="#Gradiente_sem_nome"
        y2="27.530001"
        x2="90.25"
        y1="60.259998"
        x1="89.019997"
        id="Gradiente_sem_nome_3"
      />
      <linearGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1,0,0,-1,0,58.55)"
        y2="26.700001"
        x2="128.69"
        y1="-4.3699999"
        x1="125.19"
        id="Gradiente_sem_nome"
      >
        <stop id="stop126" stopColor="#a7892f" offset="0" />
        <stop id="stop128" stopColor="#f4d96a" offset=".49" />
        <stop id="stop130" stopColor="#b4912f" offset="1" />
      </linearGradient>
      <clipPath id="clip-path-2">
        <path
          id="path144"
          d="M 77.05,6 A 11,11 0 0 0 69.2,1.36 14.51,14.51 0 0 0 67.34,1.25 C 55.46,1.25 49.75,15.62 58,23.86 a 13.24,13.24 0 0 0 18.72,0 l 9.38,-9.35 -3,-2.9 -9.21,9.6 a 9.45,9.45 0 1 1 -6.72,-16.1 8.15,8.15 0 0 1 7,3.57 z"
          className="cls-1"
        />
      </clipPath>
      <linearGradient
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(1,0,0,-1,0,58.55)"
        y2="34.419998"
        x2="57.040001"
        y1="52.419998"
        x1="78.809998"
        id="Gradiente_sem_nome_2"
      >
        <stop id="stop133" stopColor="#b68050" offset="0" />
        <stop id="stop135" stopColor="#ecb785" offset=".48" />
        <stop id="stop137" stopColor="#b67f4f" offset="1" />
      </linearGradient>
    </defs>
    <g transform="translate(0,-284.3)" id="layer1">
      <g id="g3951">
        <g transform="matrix(0.25717327,0,0,0.25717327,-13.896812,287.1395)" clipPath="url(#clip-path-2)" id="g162">
          <path
            fill="#b67f4f"
            // style={{ backgroundImage: 'linear-gradient(312deg, #b68050 124%, #ecb785 95%, #b67f4f 62%)' }}
            d="M 49.75,1.24 H 86.09 V 29.03 H 49.75 Z"
            id="path160"
          />
        </g>
        <g transform="matrix(0.25717327,0,0,0.25717327,-13.896812,287.1395)" clipPath="url(#clip-path-3)" id="g166">
          <path
            fill="#b4912f"
            // style={{ backgroundImage: 'linear-gradient(2deg, #a7892f-110%, #f4d96a-55%, #b4912f3%)' }}
            d="m 71.44,0 h 36.34 V 27.79 H 71.44 Z"
            id="path164"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default PartnerBankIcon;
